import React, {useState} from 'react';
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

import css from './PricePeriodSingleComponent.module.css';
import {periodsService} from "../../../services/settings-services";
import {periodsActions} from "../../../store/slices/settings-slices";


const PricePeriodSingleComponent = ({period}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {id, daysCount, discount} = period;

    const [dis, setDis] = useState(discount);

    const handleDiscountChange = async (e) => {
        try {
            setDis(e.target.value);

            await periodsService.updateById(id, {
                "daysCount": Number(period.daysCount),
                "discount": Number(e.target.value),
                "isDefault": period.isDefault
            });
            dispatch(periodsActions.changeTrigger());
            toast.success('Discount is updating!');
        }catch (error) {
            console.error("Error updating discount:", error);
            toast.error(t('modal-toast-creating-error'));
        }
    }


    return (
        <div className={css.wrap}>
            <div className={css.daysCount}>{daysCount}</div>
            <div className={css.discount}>
                <input type="number"
                       value={dis}
                       onChange={handleDiscountChange}
                />
            </div>
        </div>
    );
};

export default React.memo(PricePeriodSingleComponent);